import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthComponentStore } from '../../store/auth.component-store';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'epc-auth-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auth-page.component.html',
  styleUrls: ['./auth-page.component.scss'],
  providers: [AuthComponentStore],
  standalone: false,
})
export class AuthComponent {
  private componentStore = inject(AuthComponentStore);
  public availableLanguages$ = this.componentStore.availableLanguages$;
  public selectedLanguage$ = combineLatest([
    this.componentStore.selectedLanguage$,
    this.availableLanguages$,
  ]).pipe(
    map(([selected, all]) => {
      if (all.some((item) => item.id === selected)) {
        return selected;
      }

      return 'en-US';
    }),
  );

  public bg$ = this.componentStore.merchandise$;

  public setLanguage(id: string) {
    this.componentStore.setLanguage(id);
  }
}
